import 'deepmerge';

function isValueInPixel(value) {
    return /^(\d)+px$/.test(value);
}
function isArFontSize(value) {
    return ['xl', 'lg', 'md', 'sm', 'xs', 'xxs', 'xxxs'].indexOf(value) > -1
        || isValueInPixel(value);
}

var ARAvatar = {
render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'ar-profile-avatar',
    _vm.color,
    _vm.imageLoaded && 'image-loaded' ],style:({
    width: _vm.size,
    minWidth: _vm.size,
    height: _vm.size,
  }),attrs:{"ar-widget-id":"ar-avatar","ar-widget-meta":_vm.arWidgetMeta || _vm.computedArWidgetMeta,"name":"ar-avatar"}},[(_vm.imagePath && !_vm.imageLoadFailed)?_c('img',{staticClass:"ar-img-class",attrs:{"src":_vm.imagePath},on:{"error":_vm.handleImageLoadFailed,"load":_vm.handleImageLoad}}):_c('div',{staticClass:"name-section"},[_c('ar-text',{staticClass:"name-text",attrs:{"size":_vm.textSize,"text":_vm.columnDataAsInitials(_vm.name),"align":"center","weight":"bold"}})],1)])},
staticRenderFns: [],
  name: 'ARAvatar',
  props: {
    arWidgetMeta: String,
    imagePath: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: 'grey',
      validator: (value) =>
        ['grey', 'white'].indexOf(value) !== -1,
    },
    size: {
      type: String,
      default: '40px',
    },
    textSize: {
      type: String,
      default: 'xs',
      validator: isArFontSize,
    },
  },
  data() {
    return {
      imageLoadFailed: false,
      imageLoaded: false,
    };
  },
  computed: {
    computedArWidgetMeta() {
      return [
        `initials=${this.columnDataAsInitials(this.name)};`,
        `src=${this.imagePath};`,
      ].join('');
    },
  },
  methods: {
    handleImageLoad() {
      this.imageLoaded = true;
    },
    handleImageLoadFailed() {
      this.imageLoadFailed = true;
    },
    columnDataAsInitials(name) {
      if (!name) {
        return null;
      }
      const names = name.trim().split(' ');
      if (!names || names.length === 0) {
        return '';
      }
      const initialOne = `${names[0] ? names[0][0] : ''}`;
      if (names.length === 1) {
        return initialOne;
      }

      const initialTwo = `${names[names.length - 1] ? names[names.length - 1][0] : ''}`;
      return `${initialOne}${initialTwo}`;
    },
  },
};

export default ARAvatar;
